import React from 'react'
import { ShadowedContainer } from 'components/Container'
import Vendor from 'components/Vendor'
import { Col } from 'components/Col'
import ResultPrice from './ResultPrice'
import ResultBlurb from './ResultBlurb'
import styled from '@emotion/styled'
import { Button, spacer } from 'stylist'

const Wrapper = styled(ShadowedContainer)`
  .centered {
    align-items: center;
  }

  .auto-left {
    margin-left: auto;
  }

  .blurb {
    @media (max-width: 1200px) {
      display: none;
    }
    margin-left: ${spacer(4)};
    flex: 2 1 0%;
  }

  .fluid-width {
    flex: 1 1 0%;
    text-align: center;
  }

  .select-button {
    max-width: 130px;
    width: 100%;
    margin: auto;
  }
`

const Result = ({
  vendor,
  price,
  completions,
  onSelect,
  disabled,
  estimateID
}) => (
  <Wrapper>
    <Col className="centered fluid-width">
      <Vendor name={vendor.name} />
    </Col>
    <Col className="blurb">
      <ResultBlurb blurbs={vendor.marketing_text} />
    </Col>
    <Col className="auto-left fluid-width">
      <ResultPrice
        price={price ? price.toFixed(2) : '---'}
        totalPrice={price ? (price * completions).toFixed(2) : '---'}
      />
    </Col>
    <Col className="fluid-width">
      <Button
        className="select-button"
        kind="primary"
        onClick={() => onSelect(estimateID)}
        disabled={disabled || !price}
      >
        Select
      </Button>
    </Col>
  </Wrapper>
)

export default Result



// WEBPACK FOOTER //
// ./src/routes/estimate/subroutes/results/Result.js